<script setup>
import { ref } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import ConnectInboxForm from './ConnectInboxForm.vue';

defineProps({
  assistantId: {
    type: [Number, String],
    required: true,
  },
});
const emit = defineEmits(['close']);
const { t } = useI18n();
const store = useStore();

const dialogRef = ref(null);
const connectForm = ref(null);

const i18nKey = 'CAPTAIN.INBOXES.CREATE';

// Inboxes owned by another assistant come back as `skipped` rather than failing
// the request, so a bulk connect can succeed partially. Report which happened.
const resultMessage = ({ payload = [], skipped = [] }) => {
  if (!skipped.length) return t(`${i18nKey}.SUCCESS_MESSAGE`);
  if (!payload.length) return t(`${i18nKey}.NONE_CONNECTED_MESSAGE`);
  return t(`${i18nKey}.PARTIAL_SUCCESS_MESSAGE`, {
    connected: payload.length,
    skipped: skipped.length,
  });
};

const handleSubmit = async payload => {
  try {
    const result = await store.dispatch('captainInboxes/create', payload);
    useAlert(resultMessage(result));
    dialogRef.value.close();
  } catch (error) {
    const errorMessage = error?.message || t(`${i18nKey}.ERROR_MESSAGE`);
    useAlert(errorMessage);
  }
};

const handleClose = () => {
  emit('close');
};

const handleCancel = () => {
  dialogRef.value.close();
};

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="create"
    :title="$t(`${i18nKey}.TITLE`)"
    :description="$t('CAPTAIN.INBOXES.FORM_DESCRIPTION')"
    :show-cancel-button="false"
    :show-confirm-button="false"
    @close="handleClose"
  >
    <ConnectInboxForm
      ref="connectForm"
      :assistant-id="assistantId"
      @submit="handleSubmit"
      @cancel="handleCancel"
    />
    <template #footer />
  </Dialog>
</template>
